<template>
  <div class="pointer-events-none fixed bottom-4 right-4 z-[70] flex w-[min(92vw,24rem)] flex-col gap-2" aria-live="polite">
    <TransitionGroup name="pop">
      <div
        v-for="t in toasts.items"
        :key="t.id"
        role="status"
        class="pointer-events-auto flex items-start gap-3 rounded-2xl border bg-white p-4 shadow-xl dark:bg-slate-800"
        :class="borders[t.type]"
      >
        <span class="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full" :class="badges[t.type]">
          <AppIcon :name="t.type === 'success' ? 'check' : t.type === 'error' ? 'alert' : 'info'" :size="14" />
        </span>
        <p class="min-w-0 flex-1 break-words text-sm text-slate-700 dark:text-slate-200">{{ t.message }}</p>
        <button type="button" class="btn-icon -mr-2 -mt-1 h-7 w-7" aria-label="Fermer" @click="dismiss(t.id)">
          <AppIcon name="x" :size="14" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
import AppIcon from './AppIcon.vue'
import { toasts, dismiss } from '@/stores/toast'

export default {
  name: 'ToastHost',
  components: { AppIcon },
  setup() {
    return {
      toasts,
      dismiss,
      borders: {
        success: 'border-emerald-200 dark:border-emerald-900',
        error: 'border-rose-200 dark:border-rose-900',
        info: 'border-slate-200 dark:border-slate-600'
      },
      badges: {
        success: 'bg-emerald-100 text-emerald-600 dark:bg-emerald-500/15 dark:text-emerald-400',
        error: 'bg-rose-100 text-rose-600 dark:bg-rose-500/15 dark:text-rose-400',
        info: 'bg-cyan-100 text-cyan-600 dark:bg-cyan-500/15 dark:text-cyan-400'
      }
    }
  }
}
</script>
